import { Divider, Typography } from '@mui/material'
import ButtonCustom from '../../../component/button/buttonCustom'
import { useLocation, useNavigate } from 'react-router-dom';
import OTPInput from 'react-otp-input';
import { useState } from 'react';
import LoginApi from '../../../api/auth/auth.api';
// import { STORAGE_KEY } from '../../../utils/enum';
// import { logout } from '../../../utils/app.utils';
import { swalError } from '../../../component/notification/swal';
import { useTranslation } from 'react-i18next';

export default function OTPConfim() {
    const navigate = useNavigate();
    const location = useLocation()
    const { t } = useTranslation();
    const { email, ref } = location.state
    const [otp, setOTP] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false);
    // const getUserProfile = async (accessToken: string) => {
    //     await LoginApi.getUser(accessToken)
    //         .then(async (res: any) => {
    //             if (res.data.success) {
    //                 // localStorage.setItem(STORAGE_KEY.PERMISSION, JSON.stringify(res.data.result.Permissions))
    //                 localStorage.setItem(STORAGE_KEY.PROFILE, JSON.stringify(res.data.result))
    //                 window.location.href = '/confim-password'

    //             } else {
    //                 logout()
    //             }
    //         }).catch(() => logout());
    // }

    const submit = async () => {

        setLoading(true);

        await LoginApi.getValidateOTP({ email, ref, otp })
            .then(async ({data}) => {
                if (data.result) {
                    setLoading(false);
                    // localStorage.setItem(STORAGE_KEY.TOKEN, data.result.accessToken)
                    // localStorage.setItem(STORAGE_KEY.RTOKEN, data.result.refreshToken)
                    navigate('/confim-password', { state: { atoken: data.result.accessToken } })

                    // getUserProfile(data.result.accessToken)
                } else {
                    setLoading(false);
                    swalError(data.description);
                }
            })
            .catch((e) => {
                setLoading(false);
                swalError(e.response.data.description || e.response.data.message);
            })
            .finally(() => {
                setLoading(false);
            })
    };
    const resent = async () => {

        setLoading(true);

        await LoginApi.forgotPassword(email)
            .then(async ({data}) => {
                if (data.result) {
                    setLoading(false);
                    navigate('/OTP-confim', { state: { email: email, ref: data.result.ref } })

                } else {
                    setLoading(false)
                    swalError(data.description);
                }
            })
            .catch((e) => {
                setLoading(false);
                swalError(e.response.data.description);
            })
            .finally(() => {
                setLoading(false);
            })
    };
    return (
        <div style={{
            width: "100%",
            gap: '36px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <Divider orientation="horizontal" flexItem>
                <Typography sx={{ color: '#858C95' }}>{t('OTPCONFIM.TITLE')}</Typography>
            </Divider>
            <div style={{ width: "100%" }}>
                <div style={{ width: "100%", display: "flex", marginBottom: '16px' }}>
                    <Typography sx={{ color: '#323539', marginRight: "12px" }}>OTP Refer: {ref}</Typography>
                    <Typography onClick={() => resent()} sx={{ color: '#0A77FF', textDecorationLine: 'underline' }}>{t('OTPCONFIM.RESENT')}</Typography>
                </div>

                <OTPInput
                    value={otp}
                    onChange={setOTP}
                    numInputs={6}
                    renderSeparator={<span style={{ marginLeft: '8px' }}></span>}
                    renderInput={(props) => <input {...props} />}
                    inputType='tel'
                    inputStyle={{
                        width: '50px',
                        height: '60px',
                        fontSize: '24px',
                        fontWeight: 700,
                        color: '#000',
                        backgroundColor: '#F8F9FB',
                        border: `1px solid #E5E5E7`,
                        borderRadius: "4px",
                        outline: 'none',
                    }}
                    containerStyle={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                />
            </div>

            <ButtonCustom
                type="submit"
                onClick={() => {
                    submit()
                }}
                disabled={loading || otp.length < 6}
                textButton={t('OTPCONFIM.BUTTON.SUBMMIT')}
                btnStyle={{
                    fontSize: "16px",
                    width: "100%",
                }}
                style={{ width: "100%", }}
            />
        </div>
    )
}
